import { createContext, useState, useContext } from "react";

const ModalContext = createContext();

export const ModalProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [modalContent, setModalContent] = useState(null);
  const [modalTitle, setModalTitle] = useState(null);
  const [modalSize, setModalSize] = useState(null);

  const openModal = (content, title, size) => {
    setModalContent(content);
    setModalTitle(title);
    setModalSize(size);
    setIsOpen(true);
  };
  
  const closeModal = () => {
    setIsOpen(false);
    setModalContent(null);
    setModalSize(null);
    setModalTitle(null);
  };

  return (
    <ModalContext.Provider value={{ isOpen, openModal, closeModal, modalContent, modalTitle, modalSize }}>
      {children}
    </ModalContext.Provider>
  );
};

export const useModal = () => useContext(ModalContext);
